const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Registration Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('RegistrationData', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/registration-data/:subresource', null, {
    checkActive: {params: {subresource: 'active'}, method: 'GET', isArray: false},
    initialSubmit: {params: {subresource: 'initial'}, method: 'POST', isArray: false},
    secondSubmit: {params: {subresource: 'second'}, method: 'POST', isArray: false}
  });

}]);
